<template>
  <div class="quotation-page upper-input">
    <div class="one-right">
      <h1>RacingMax</h1>
    </div>
    <div class="one-right">
      <h2>QBE Motor Cycle Insurance System</h2>
    </div>
    <div class="one-right">
      <div class="bar">
        <div class="btn-home">
          <el-button
            size="small"
            @click="$router.replace('/')"
          >
            Home
          </el-button>
        </div>
        <div class="step-container">
          <div class="step active">
            <span class="step_n">1</span>
            <span>Quote</span>
          </div>
          <span class="line" />
          <div class="step">
            <span class="step_n">2</span>
            <span>Policy</span>
          </div>
        </div>
      </div>
    </div>
    <el-form
      ref="form"
      :rules="rules"
      :model="formData"
      :disabled="disabledStatusForm"
    >
      <div class="bg-gray">
        <div class="one-right">
          <h3>Racing Max Information</h3>
        </div>
        <div class="form-box">
          <div class="tr">
            <div class="left">
              Office Location
            </div>
            <div class="right">
              <el-form-item
                ref="office"
                prop="office"
              >
                <v-select
                  v-model="formData.office"
                  :list="allOptions.office"
                />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Account Number
            </div>
            <div class="right">
              <el-form-item
                ref="account_no"
                prop="account_no"
              >
                <v-input
                  v-model="formData.account_no"
                  :disabled="true"
                />
              </el-form-item>
            </div>
          </div>

          <div class="tr">
            <div class="left">
              Effective Date & Time
            </div>
            <div class="right">
              <el-form-item
                ref="pcy_cmnt_dt"
                prop="pcy_cmnt_dt"
              >
                <v-datetime-picker v-model="formData.pcy_cmnt_dt" />
              </el-form-item>
            </div>
          </div>


          <div class="tr">
            <div class="left">
              Business Type
            </div>
            <div class="right">
              <el-form-item
                ref="business_type"
                prop="business_type"
              >
                <v-select
                  v-model="formData.business_type"
                  :list="allOptions.business_type"
                />
              </el-form-item>
            </div>
          </div>

          <div
            v-if="formData.business_type == 20"
            class="tr">
            <div class="left">
              Replacing Policy No.
            </div>
            <div class="right">
              <el-form-item
                ref="rep_pcy_no"
                prop="rep_pcy_no"
              >
                <v-input
                  v-model="formData.rep_pcy_no"
                  :maxlength="8"
                />
              </el-form-item>
            </div>
          </div>




          <div class="tr">
            <div class="left">
              Proposer Type
            </div>
            <div class="right">
              <el-form-item
                ref="cust_typ"
                prop="cust_typ"
              >
                <v-select
                  v-model="formData.cust_typ"
                  :list="proposerTypeOptions"
                />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Vehicle Usage
            </div>
            <div class="right">
              <el-form-item
                ref="usage_ind"
                prop="usage_ind"
              >
                <v-select
                  v-model="formData.usage_ind"
                  :list="allOptions.usage"
                />
              </el-form-item>
            </div>
          </div>

          

        </div>
      </div>
      <div class="bg-white">
        <div class="one-right">
          <h3>Vehicle Information</h3>
        </div>
        <div class="form-box">
          <div class="tr">
            <div class="left">
              Internal Body Type
            </div>
            <div class="right">
              <el-form-item
                ref="typ_of_bdy_id"
                prop="typ_of_bdy_id"
              >
                <v-select
                  v-model="formData.typ_of_bdy_id"
                  :list="allOptions.body_type"
                />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Display Body Type
            </div>
            <div class="right">
              <el-form-item
                ref="rgtn_bdy"
                prop="rgtn_bdy"
              >
                <v-input
                  v-model="formData.rgtn_bdy"
                />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Make
            </div>
            <div class="right">
              <el-form-item
                ref="brand"
                prop="brand"
              >
                <v-autocomplete
                  v-model="formData.brand"
                  :list="allOptions.make"
                  @select="handlerSelectBrand" />
                <!-- <v-select
                  v-model="formData.brand_id"
                  :filterable="true"
                  :list="allOptions.make"
                /> -->
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Cubic Capacity
            </div>
            <div class="right">
              <el-form-item
                ref="engn_cpcty"
                prop="engn_cpcty"
              >
                <v-input
                  v-model="formData.engn_cpcty"
                  :max="Number(9999)"
                  type="number"
                />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Year of Manufacturing
            </div>
            <div class="right">
              <el-form-item
                ref="rgtn_yr"
                prop="rgtn_yr"
              >
                <v-input v-model="formData.rgtn_yr" />
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-gray">
        <div class="one-right">
          <h3>Driver Information</h3>
        </div>
        <div class="form-box">
          <div class="tr">
            <div class="left">
              Driving License Type
            </div>
            <div class="right">
              <el-form-item
                ref="nm_drvr_exp_1"
                prop="nm_drvr_exp_1"
              >
                <v-select
                  v-model="formData.nm_drvr_exp_1"
                  :list="allOptions.driver_license_type"
                />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Date of Birth (DD-MM-YYYY)
            </div>
            <div class="right">
              <el-form-item
                ref="nm_drvr_dob_1"
                prop="nm_drvr_dob_1"
              >
                <v-date-picker v-model="formData.nm_drvr_dob_1" />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Occupation
            </div>
            <div class="right">
              <el-form-item
                ref="nm_drvr_occ_1"
                prop="nm_drvr_occ_1"
              >
                <v-input
                  v-model="formData.nm_drvr_occ_1"
                  maxlength="60" />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              NCD
            </div>
            <div class="right">
              <el-form-item
                ref="ncd_pct"
                prop="ncd_pct"
              >
                <v-select
                  v-model="formData.ncd_pct"
                  :list="allOptions.ncd"
                />
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white">
        <div class="one-right">
          <h3>Premium Details</h3>
        </div>
        <div class="form-box">
          <div class="tr">
            <div class="left">
              Basic Premium
            </div>
            <div class="right">
              <el-form-item
                ref="base_prm"
                prop="base_prm"
              >
                <v-input
                  v-model="formData.base_prm"
                  type="number"
                  prepend="HK"
                />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Loading
            </div>
            <div class="right">
              <el-form-item
                ref="loading_pct"
                prop="loading_pct"
              >
                <v-input
                  v-model="formData.loading_pct"
                  type="number"
                  append="%"
                />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Client Discount
            </div>
            <div class="right">
              <el-form-item
                ref="srd_pct"
                prop="srd_pct"
              >
                <v-input
                  v-model="formData.srd_pct"
                  type="number"
                  append="%"
                />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              MIB
            </div>
            <div class="right">
              <el-form-item
                ref="mib_pct"
                prop="mib_pct"
              >
                <v-input
                  v-model="formData.mib_pct"
                  :disabled="true"
                  type="number"
                  append="%"
                />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              IA Levy
            </div>
            <div class="right">
              <el-form-item
                ref="ia_levy_pct"
                prop="ia_levy_pct"
              >
                <v-input
                  v-model="formData.ia_levy_pct"
                  :disabled="true"
                  type="number"
                  append="%"
                />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Gross Premium
            </div>
            <div class="right">
              <v-input
                v-model="gross"
                type="number"
                prepend="HK"
              />
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Total Premium
            </div>
            <div class="right">
              <v-input
                v-model="total"
                type="number"
                prepend="HK"
              />
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Adjusted Premium
            </div>
            <div class="right">
              <el-form-item
                ref="payable"
                prop="payable"
              >
                <v-input
                  v-model="formData.payable"
                  prepend="HK"
                  type="number"
                />
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-gray">
        <div class="one-right">
          <h3>Excess Terms (Section II)</h3>
        </div>
        <div class="form-box">
          <div class="tr">
            <div class="left">
              TPPD
            </div>
            <div class="right">
              <v-input
                v-model="formData.tppd_ex"
                prepend="HK"
              />
            </div>
          </div>
          <div class="tr">
            <div class="left">
              TPPD(Y)
            </div>
            <div class="right">
              <v-input
                v-model="formData.tppd_young_driver_ex"
                prepend="HK"
              />
            </div>
          </div>
          <div class="tr">
            <div class="left">
              TPPD(I)
            </div>
            <div class="right">
              <v-input
                v-model="formData.tppd_inexp_driver_ex"
                prepend="HK"
              />
            </div>
          </div>
          <div class="tr">
            <div class="left">
              TPPD(U)
            </div>
            <div class="right">
              <v-input
                v-model="formData.tppd_unnamed_driver_ex"
                prepend="HK"
              />
            </div>
          </div>
        </div>
      </div>
    </el-form>

    <div class="btn-container one-right">
      <el-button
        type="primary"
        @click="handleNext"
      >
        Next
      </el-button>
    </div>
    <el-button
      v-if="dev"
      type="danger"
      size="mini"
      class="btn-text"
      @click="handleText"
    >
      數據填充
    </el-button>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import options from '@/mixins/options'
import OMath from '@/jslib/math'
export default {
  name: 'Quotation',
  mixins: [options],
  data() {
    const checkPayable = (rules, value, callback) => {
      if(value) {
        const total = OMath.number(this.total)
        if(total < OMath.number(value)) {
          callback(new Error('Adjusted Premium 必須小於 Total Premium'))
        }
      }
      callback()
    }
    const checkEngnCpcty = (rules, value, callback) => {
      if(value.length > 4) {
        callback(new Error('請填寫小於 4 位的正整數'))
      }
      callback()
    }
    // 檢查年份
    const checkYear = (rule, value, callback) => {
      const reg = /19[0-9]{2}|20[0-9]{2}/
      const y = new Date().getFullYear()
      if (!reg.test(value) || value > y) {
        callback(new Error('請輸入正確的年份'))
      }
      callback()
    }
    return {
      total: 0,
      formData: {
        office: '',
        account_no: '',
        business_type: '',
        rep_pcy_no: '',
        usage_ind: '',
        typ_of_bdy_id: '',
        brand: '',
        brand_id: '',
        engn_cpcty: '',
        rgtn_yr: '',
        nm_drvr_exp_1: '2',
        nm_drvr_dob_1: '',
        nm_drvr_occ_1: '',
        ncd_pct: '',
        base_prm: '3700',
        loading_pct: '',
        srd_pct: '',
        mib_pct: '3',
        ia_levy_pct: '0.06',
        // gross: '',
        payable: '',
        tppd_ex: '',
        tppd_young_driver_ex: '',
        tppd_inexp_driver_ex: '',
        tppd_unnamed_driver_ex: '',
        pcy_cmnt_dt: '',
        cust_typ: 1,
        rgtn_bdy: '',
      },
      selectBrand: {},
      rules: {
        cust_typ: [
          { required: true, message: 'Please Select', trigger: ['change', 'blur'] }
        ],
        office: [
          { required: true, message: 'Please Select', trigger: ['change', 'blur'] }
        ],
        account_no: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] }
        ],
        business_type: [
          { required: true, message: 'Please Select', trigger: ['change', 'blur'] }
        ],
        usage_ind: [
          { required: true, message: 'Please Select', trigger: ['change', 'blur'] }
        ],
        typ_of_bdy_id: [
          { required: true, message: 'Please Select', trigger: ['change', 'blur'] }
        ],
        rgtn_bdy: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] }
        ],
        brand: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] }
        ],
        engn_cpcty: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] },
          { validator: checkEngnCpcty, trigger: ['change', 'blur'] }
        ],
        rgtn_yr: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] },
          { validator: checkYear, trigger: ['change', 'blur'] }
        ],
        nm_drvr_exp_1: [
          { required: true, message: 'Please Select', trigger: ['change', 'blur'] }
        ],
        nm_drvr_dob_1: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] }
        ],
        nm_drvr_occ_1: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] }
        ],
        ncd_pct: [
          { required: true, message: 'Please Select', trigger: ['change', 'blur'] }
        ],
        base_prm: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] }
        ],
        loading_pct: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] }
        ],
        srd_pct: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] }
        ],
        mib_pct: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] }
        ],
        ia_levy_pct: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] }
        ],
        payable: [
          { required: false, message: 'Please Enter', trigger: ['change', 'blur'] },
          { validator: checkPayable, trigger: ['change', 'blur'] }
        ],
        pcy_cmnt_dt: [
          { required: true, message: 'Please Select', trigger: ['change', 'blur'] }
        ],
        rep_pcy_no: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] }
        ],
      },
      proposerTypeOptions: [
        {
          name: 'Individual',
          id: 1
        },
        {
          name: 'Company',
          id: 2
        }
      ]
    }
  },
  computed: {
    ...mapState('policy', ['policyForm']),
    // ia_levy_pct() {
    //   return new Date('2020-04-1').getTime() > new Date().getTime()? '0.06': '0.085'
    // },
    gross() {
      let { base_prm, srd_pct, loading_pct, ncd_pct } = this.formData
      const srd_rate = srd_pct / 100
      const loading_rate = loading_pct / 100
      const ncd_rate = ncd_pct / 100

      const gross1 = OMath.round(base_prm * (1 - srd_rate))
      const gross2 = OMath.round(gross1 * (1 + loading_rate))
      const gross3 = OMath.round(gross2 * (1 - ncd_rate))

      return gross3

      // return OMath.round(
      //   base_prm * (1 - srd_rate) * (1 + loading_rate) * (1 - ncd_rate)
      // )
    },
    totalValue() {
      let { mib_pct, ia_levy_pct } = this.formData
      const mib_val = OMath.round(this.gross * (mib_pct / 100))
      const ia_levy_val = OMath.round(this.gross * (ia_levy_pct / 100))
      const totalVal = OMath.number(this.gross) + OMath.number(mib_val) + OMath.number(ia_levy_val)
      return OMath.round(totalVal)
    },
    dev() {
      return process.env.NODE_ENV === 'development'
    },
    disabledStatusForm() {
      let userinfo = JSON.parse(localStorage.getItem('userinfo'))
      if(userinfo && userinfo.super_admin){
        return false
      }else{
        return this.formData.lock === 1
      }
    }
  },
  watch: {
    totalValue: {
      immediate: true,
      handler(val) {
        this.total = val
      }
    },
    'formData.office': {
      immediate: true,
      handler(val) {
        // eslint-disable-next-line
        this.formData.account_no = val == 1? '01-10000358-008': '01-10000357-008'
      }
    },
    'formData.pcy_cmnt_dt': {
      immediate: true,
      handler(val) {
        // 截取
        const s = String(val)
        let y = s.substr(6, 4)
        let m = s.substr(3, 2)
        let d = s.substr(0, 2)
        let time = s.substr(11, 5)
        let datetime = new Date(`${y}-${m}-${d} ${time}`).getTime()

        let ia_levy_pct = '0.06'
        // 規則
        if(datetime >= new Date('2021-04-01 00:00').getTime()) {
          ia_levy_pct = '0.1'
        } else if (datetime >= new Date('2020-04-01 00:00').getTime()) {
          ia_levy_pct = '0.085'
        } else if (datetime >= new Date('2019-04-01 00:00').getTime()) {
          ia_levy_pct = '0.06'
        } else {
          ia_levy_pct = '0.04'
        }
        this.formData.ia_levy_pct = ia_levy_pct

        // 動態設置 MIB 的值
        if(
          val &&
          datetime >= new Date('2021-10-01 00:00').getTime()
          && datetime <= new Date('2022-09-30 23:59').getTime()
        ) {
          this.$set(this.formData, 'mib_pct', 0)
        }
        else {
          this.$set(this.formData, 'mib_pct', 3)
        }

        // this.formData.ia_levy_pct = new Date('2020-04-01 00:00').getTime() > new Date(datetime).getTime()? '0.06': '0.085'
      }
    }
  },
  created() {
    this.updateAllOptions()
    const { office = '' } = this.$route.query
    if(office) {
      this.formData.office = this.getAllOptionsId('office', office) || ''
    }

    if(this.policyForm) {
      // 移除 gross
      let tempPolicyForm = JSON.parse(JSON.stringify(this.policyForm))
      delete tempPolicyForm.gross
      delete tempPolicyForm.total
      this.formData = Object.assign(this.formData, tempPolicyForm)
    }
  },
  methods: {
    ...mapActions('main', ['updateAllOptions']),
    ...mapActions('policy', ['setPolicyForm', 'setPolicyId']),
    handlerSelectBrand(item) {
      this.selectBrand = item
      this.formData.brand_id = item.id
    },
    handleText() {
      Object.assign(this.formData, {
        // office: '1',
        // account_no: '123456',
        business_type: '10',
        rep_pcy_no: 'v1234567',
        usage_ind: '0',
        typ_of_bdy_id: '20',
        rgtn_bdy: 'MOTORCYCLE',
        brand: 'BMW',
        brand_id: '9',
        engn_cpcty: '125',
        rgtn_yr: '2019',
        // nm_drvr_exp_1: '2',
        nm_drvr_dob_1: '01-01-1990',
        nm_drvr_occ_1: 'Worker',
        ncd_pct: '10',
        // base_prm: '2000',
        loading_pct: '10',
        srd_pct: '10',
        // mib_pct: '10',
        // ia_levy_pct: '10',
        payable: '2000',
        tppd_ex: '2000',
        tppd_young_driver_ex: '2000',
        tppd_inexp_driver_ex: '2000',
        tppd_unnamed_driver_ex: '2000',
        pcy_cmnt_dt: '21-03-2021 19:20'
      })
    },
    handleNext() {
      this.$refs['form'].validate((valid, options) => {
        if(valid) {
          // if(this.formData.brand !== this.selectBrand.name) {
          //   this.formData.brand_id = 0
          // }
          const { brand } = this.formData
          // getAllOptionsName
          const id = this.getAllOptionsId('make', brand)
          this.formData.brand_id = id? id: 0

          this.setPolicyForm({
            ...this.formData,
            gross: this.gross,
            total: this.total
          })
          // this.setPolicyId('')
          this.$router.push({
            path: '/application'
          })
        } else {
          Object.keys(options).some(key => {
            const dom = this.$refs[key]
            const top = dom.$el.offsetTop 
            document.getElementById('scroll-content').scrollTop = top - 50
            return true
          })
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.quotation-page {
  text-align: center;
  color: #303133;
  h1 {
    font-size: 32px;
  }
  h2 {
    margin-bottom: 20px;
    font-size: 24px;
  }
  h3 {
    margin-bottom: 15px;
    font-size: 16px;
  }
  .one-right {
    margin: 0 auto;
    padding-left: 210px;
    width: 710px;
    text-align: left;
  }
  .bar {
      display: flex;
      align-items: center;
      padding: 15px 0;
      .btn-home {
          margin-right: 100px;
      }
  }
  .step-container {
    display: flex;
    .line {
        display: block;
        margin-top: 12px;
        margin-left: -11px;
        margin-right: -10px;
        width: 160px;
        height: 2px;
        background: #DDDFE7;
    }
    .step {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      font-size: 16px;
      font-weight: bold;
      color: #DDDFE7;
      &.active {
          color: #303133;
          .step_n {
              border: 2px solid #303133;
          }
      }
      .step_n {
        display: block;
        margin-bottom: 7px;
        width: 24px;
        height: 24px;
        line-height: 18.5px;
        border: 2px solid #DDDFE7;
        border-radius: 100%;
        text-align: center;
      }
    }
  }
  .left {
    width: 230px;
    text-align: right;
    color: #616266;
    font-size: 16px;
  }
  .right {
    margin-left: 10px;
    width: 500px;
    text-align: left;
  }
  .tr {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
  }
  .bg-gray {
    padding: 20px 0;
    background: #f8f8f8;
  }
  .bg-white {
    padding: 20px 0;
    background: white;
  }
  .btn-container {
    margin: 30px auto 50px auto;
  }
}
</style>